<template>
  <span v-if="model.$diff" :path="model.$path">
    <span class="prev-value">{{model.$diff.$prevValue}}</span>
    <span class="new-value">{{model.$diff.$newValue}}</span>
  </span>

  <span v-else>{{model.$value}}</span>
</template>

<script>
export default {
  props: ['model']
};
</script>

